/* global axios */
import ApiClient from './ApiClient';

// AIVIO timers: backed by fixes/timers/aivio_timers_controller.rb (admin-only).
// get/create/update/delete come from ApiClient (/api/v1/accounts/:id/aivio/timers).
class AivioTimersAPI extends ApiClient {
  constructor() {
    super('aivio/timers', { accountScoped: true });
  }

  // Counts conversations matching the condition right now; nothing is saved.
  preview(data) {
    return axios.post(`${this.url}/preview`, data);
  }

  getLog(limit = 100) {
    return axios.get(`${this.url}/log`, { params: { limit } });
  }
}

export default new AivioTimersAPI();
